import { Context } from '@micro-frontend-react/employee-experience/lib/Context';
import { IEmployeeExperienceContext } from '@micro-frontend-react/employee-experience/lib/IEmployeeExperienceContext';
import { useContext } from 'react';
import * as React from 'react';

export function useIsGuest(): boolean {
  const { telemetryClient } = useContext(Context as React.Context<IEmployeeExperienceContext>);
  const { search } = window.location;

  let query = React.useMemo(() => new URLSearchParams(search), [search]);
  let isGuest: boolean = query.get('isGuest')?.toLowerCase() === 'true';

  telemetryClient.trackTrace({
    message: isGuest ? 'InGuestMode' : 'InUserMode',
  });

  return isGuest;
}
